import { render } from "./PromotionReferFriendView.vue?vue&type=template&id=4c61caa6&scoped=true"
import script from "./PromotionReferFriendView.vue?vue&type=script&lang=js"
export * from "./PromotionReferFriendView.vue?vue&type=script&lang=js"

import "./PromotionReferFriendView.vue?vue&type=style&index=0&id=4c61caa6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c61caa6"]])

export default __exports__